"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_components_1 = require("@apollo/react-components");
var React = __importStar(require("react"));
var App_1 = require("../App");
var apollo_1 = require("../Common/utils/apollo");
var useTracking_1 = __importDefault(require("../Common/utils/useTracking"));
var StripeContainer_1 = __importDefault(require("../VerifyPaymentCard/StripeContainer"));
var ThreeDSecureAuthView_1 = __importDefault(require("./ThreeDSecureAuthView"));
var ThreeDSecureContext_1 = require("./ThreeDSecureContext");
var ThreeDSecureChallenge = function (_a) {
    var orderCart = _a.orderCart, stripeKey = _a.stripeKey, _b = _a.resumeOrder, resumeOrder = _b === void 0 ? false : _b;
    var trackLoad = useTracking_1["default"]().trackLoad;
    React.useEffect(function () {
        trackLoad(orderCart.id);
    }, []);
    var _c = React.useContext(App_1.RiskContext), client = _c.client, language = _c.language, proxyOverride = _c.proxyOverride, authToken = _c.authToken, riskBffConfig = _c.riskBffConfig;
    var apolloClient = React.useMemo(function () {
        return client ||
            apollo_1.configureApollo(language, proxyOverride, authToken, riskBffConfig);
    }, [orderCart.id]);
    return (React.createElement(react_components_1.ApolloProvider, { client: apolloClient },
        React.createElement(StripeContainer_1["default"], { stripeKey: stripeKey },
            React.createElement(ThreeDSecureContext_1.ThreeDSecureProvider, { orderCart: orderCart },
                React.createElement(ThreeDSecureAuthView_1["default"], { resumeOrder: resumeOrder })))));
};
exports["default"] = ThreeDSecureChallenge;
